import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./allCoupons.css";

const AllCoupons = () => {
  const [allCoupons, setAllCoupons] = useState([]);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    fetchCoupons();
  }, [API_BASE_URL]);

  const formatDate = (dateString) => {
    console.log("Formatting date:", dateString);
    if (!dateString) return "Invalid Date";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  const fetchCoupons = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/coupons`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      console.log(response.data);
      setAllCoupons(response.data);
    } catch (error) {
      console.error("Error fetching coupons:", error);
    }
  };

  const handleAddNewCoupons = () => {
    navigate("/add-coupons");
  };

  const handleEdit = (id) => {
    navigate(`/edit-coupons/${id}`);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this coupon?")) {
      try {
        await axios.delete(`${API_BASE_URL}/admin/coupons/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        alert("Coupon deleted successfully!");
        fetchCoupons(); // Refresh the coupon list
      } catch (error) {
        console.error("Error deleting coupon:", error);
        alert("Failed to delete the coupon. Please try again.");
      }
    }
  };

  return (
    <div id="classes-inner-wrapper">
      <div className="classes-header-div">
        <h5>All Offer And Coupons</h5>
        <div className="classes-header-btns">
          <button className="add-class-btn" onClick={handleAddNewCoupons}>
            + Add New Coupon
          </button>
          <button className="all-classes-btn" onClick={fetchCoupons}>
            Refresh
          </button>
        </div>
      </div>

      <div className="classes-table-container">
        <h5>All Coupons</h5>
        <table className="classes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>User Type</th>
              <th>Coupon Code</th>
              <th>Coupon Value %</th>
              <th>Coupon Limit</th>
              <th>Expiry Date</th>
              <th>Category</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {allCoupons.length > 0 ? (
              allCoupons.map((data, idx) => (
                <tr key={data._id} className="box-border">
                  <td>{idx + 1}</td>
                  <td>{data.userType}</td>
                  <td>{data.couponCode}</td>
                  <td>{data.value}</td>
                  <td>{data.limit}</td>
                  <td>
                    {data.expiryDate
                      ? formatDate(data.expiryDate)
                      : "No Expiry Date"}
                  </td>
                  <td>
                    {data?.category && data?.category.length > 0
                      ? data?.category.map((item) => <p>{item}</p>)
                      : "N/A"}
                  </td>
                  <td>{data.status}</td>
                  <td className="table-action-icons">
                    <i
                      className="fa-solid fa-file-pen"
                      onClick={() => handleEdit(data._id)}
                      style={{ cursor: "pointer", color: "blue" }}
                    ></i>
                    &nbsp;&nbsp;
                    <i
                      className="fa-solid fa-trash-can"
                      onClick={() => handleDelete(data._id)}
                      style={{ cursor: "pointer", color: "red" }}
                    ></i>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">
                  <h1>No Data Found</h1>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllCoupons;
